
import styles from "./projectInfoCardView.module.scss";
import { Link } from "react-router-dom";
import iconDelete from './assets/close-icon.svg'

export interface ProjectInfoCardViewProps {
  description?: string;
  title?: string;
  location?: string;
  onClick?: () => void;
  linkTo?: string;
  noDescriptionLabel?: boolean;
  maxWidth?: string;
  maxCharDescription?: number;
  onDelete?: () => void;
  project_status?: string;
}
export default function ProjectInfoCardView({
  title,
  description,
  noDescriptionLabel,
  maxWidth,
  maxCharDescription,
  onClick,
  linkTo,
  onDelete,
  project_status,
}: ProjectInfoCardViewProps) {
  const style = {
    maxWidth: maxWidth || "350px",
  };
  if (
    maxCharDescription &&
    description &&
    description.length > maxCharDescription
  ) {
    description = description.slice(0, maxCharDescription) + "...";
  }

  const getStatusLabel = (status?: string) => {
    if (!status) return "";
    switch (status) {
      case "PLANNED":
        return "Planifié";
      case "STARTED":
        return "Démarré";
      case "FINISHED":
        return "Terminé";
      default:
        return status;
    }
  };

  const getStatusClass = (status?: string) => {
    if (!status) return styles["project-info__status"];
    switch (status) {
      case "PLANNED":
        return `${styles["project-info__status"]} ${styles["project-info__status--planned"]}`;
      case "STARTED":
        return `${styles["project-info__status"]} ${styles["project-info__status--started"]}`;
      case "FINISHED":
        return `${styles["project-info__status"]} ${styles["project-info__status--finished"]}`;
      default:
        return styles["project-info__status"];
    }
  };

  const content = (
    <>
      {onDelete && (
        <button
          className={styles["project-info__delete-btn"]}
          onClick={(e) => {
            e.preventDefault();
            onDelete();
          }}
        >
          <img src={iconDelete} alt="delete icon" />
        </button>
      )}
      <h3 className={styles["project-info__title"]}>{title}</h3>
      {project_status && (
        <span className={getStatusClass(project_status)}>
          {getStatusLabel(project_status)}
        </span>
      )}
      {description && (
        <>
          {!noDescriptionLabel && (
            <h4 className={styles["project-info__description-label"]}>
              Description
            </h4>
          )}
          <p className={styles["project-info__description-text"]}>
            {description}
          </p>
        </>
      )}
    </>
  );

  if (linkTo) {
    return (
      <Link to={linkTo} style={style}  className={[styles["project-info"], styles["project-info--clickable"]].join(" ")}>
        {content}
      </Link>
    );
  }

  return (
    <div
      style={style}
      className={[styles["project-info"], onClick && styles["project-info--clickable"]].join(" ")}
      onClick={(e) => {
        e.preventDefault();
        if (onClick) onClick();
      }}

    >
      {content}
    </div>
  );
}
